"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = isObject;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function isObject(x) {
  return x != null && (0, _typeof2.default)(x) === 'object';
}